import styled, { css } from "styled-components";
import { Paragraph } from "../Typography";

export const SelectionsContainer = styled.div`
  display: flex;
  flex-flow: row;
  row-gap: var(--fd-space-space-1);
  flex-shrink: 0;
`;

export const SaddleSelectionContainer = styled.div<{
  isDetailView: boolean;
}>`
  display: flex;
  column-gap: var(--fd-space-space-1);
  ${({ isDetailView }) =>
    isDetailView
      ? "flex-direction: column"
      : css`
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;
        `};
  row-gap: var(--fd-space-space-3);
  width: 100%;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-flow: row;
  column-gap: var(--fd-space-space-1);
`;

export const RowContainer = styled.div<{
  isDetailView: boolean;
  showReplacedRunners?: boolean;
}>`
  align-items: center;
  ${({ isDetailView }) =>
    isDetailView
      ? `display: grid;
        column-gap: var(--fd-space-space-1);
        row-gap: var(--fd-space-space-3);
        grid-template-columns: min-content 1fr min-content;`
      : "display: flex; flex-direction: row; column-gap: var(--fd-space-space-1);"}
`;

export const AlternatePlaceholder = styled.div`
  display: flex;
  align-items: center;
  column-gap: var(--fd-space-space-1);
  margin-left: var(--fd-space-space-1);
`;

export const AlternateDivider = styled.div<{ isDark: boolean }>`
  height: 12px;
  width: 1px;
  background-color: ${({ isDark }) =>
    isDark
      ? `var(--fd-colors-content-on-dark)`
      : `var(--fd-colors-content-subtle)`};
`;

export const IconContainer = styled.div<{
  isDetailView?: boolean;
}>`
  align-items: center;
  flex-direction: row;
  height: 20px;
  width: 20px;
  position: relative;
`;

export const SaddleDetailsParagraph = styled(Paragraph)<{
  scratched?: boolean;
}>`
  margin-left: var(--fd-space-space-1);
  text-decoration: ${({ scratched }) => (scratched ? "line-through" : "none")};
`;
